<template>
  <q-btn-dropdown
    ref="button"
    class="filter-select-button"
    color="white"
    text-color="black"
    outline
    data-test="filter-select-button"
    content-style="overflow: hidden !important;"
    @hide="closeDropDown()"
  >
    <template #label>
      <label class="label">
        {{ labelToRender }}
        <div v-if="isLoading" class="loading">
          <q-spinner
            color="primary"
            size="1em"
          />
        </div>
      </label>
    </template>
    
    <div class="inner-label q-pa-sm">
      Filter {{ label }}
    </div>
    <q-input
      v-model="searchTerm"
      class="search"
      outlined
      :label="'Search ' + label"
      clearable
      data-test="filter-select-search"
    >
      <template #prepend>
        <q-icon name="search" color="black" size="sm" />
      </template>
    </q-input>

    <div class="selected-count">
      {{ localSelected.length }} selected
    </div>
        
    <q-list ref="listEl" :style="`height: ${listHeight}px`" data-test="filter-select-dropdown">
      <q-item v-for="option in filteredList" :key="option.value" clickable @click.prevent="toggleSelection(option.value)">
        <q-item-section style="min-width: 20px; padding-right: 8px;" avatar>
          <span class="material-icons-outlined check-box" :class="[(localSelected.indexOf(option.value) === -1) ? 'check-box-outline-blank' : 'check-box-checked']">
            {{ (localSelected.indexOf(option.value) === -1) ? 'check_box_outline_blank' : 'check_box' }}
          </span>
        </q-item-section>
        <q-item-section>{{ option.label }}</q-item-section>
      </q-item>
    </q-list>
    
    <div class="controls row justify-between">
      <q-btn class="clear q-px-sm" @click.prevent="closeDropDown('clear')">
        Clear
      </q-btn>
      <div class="row flex justify-end">
        <q-btn class="cancel col-auto" @click.prevent="closeDropDown('cancel')">
          Cancel
        </q-btn>
        <q-btn class="save col-auto" @click.prevent="closeDropDown()">
          OK
        </q-btn>
      </div>
    </div>
  </q-btn-dropdown>
</template>

<script setup>
import { ref, defineProps, defineEmits, computed, onMounted, watch } from 'vue'
import { array, string, bool } from 'vue-types'

const props = defineProps({
  list: array(),
  selected: array(),
  label: string(),
  labelSingular: {
    type: String,
    default: '',
  },
  isLoading: bool(false)
})

const emit = defineEmits(['updateSelected'])

const button = ref()
const listEl = ref()
const searchTerm = ref(null)

const localSelected = ref([])
const filteredList = computed({
  get: () => {
    if (searchTerm.value === null) {
      return props.list
    } else {
      return props.list.filter(option => option.label.toLowerCase().indexOf(searchTerm.value.toLowerCase()) > -1)
    }
  }
})

onMounted(() => {
  localSelected.value = JSON.parse(JSON.stringify(props.selected))
})

watch(() => props.selected, (val) => {
  localSelected.value = JSON.parse(JSON.stringify(val))
})

const listHeight = computed(() => {
  if (listEl.value) {
    return listEl.value.$el.parentElement.clientHeight - (40 + 40 + 56 + 60)
  }
  return 500
})

const labelToRender = computed(() => {
  const number = (props.selected.length > 0) ? props.selected.length : 'All'
  if (number === 1) {
    return `${number} ${props.labelSingular ? props.labelSingular : props.label.substring(0, props.label.length - 1)}`
  } else {
    return `${number} ${props.label}`
  }
})

function toggleSelection(code) {
  const index = localSelected.value.indexOf(code)
  if (index > -1) {
    localSelected.value.splice(index, 1)
  } else {
    localSelected.value.push(code)
  }
}
function closeDropDown(action = '') {
  switch (action) {
  case 'cancel':
    localSelected.value = JSON.parse(JSON.stringify(props.selected))
    break
  case 'clear':
    localSelected.value = []
    emit('updateSelected', localSelected.value)
    break
  default:
    emit('updateSelected', localSelected.value)
    break
  }
  searchTerm.value = null
  button.value.hide()
}
</script>

<style lang="scss" scoped>
:deep(.q-focus-helper) {
  display: none;
}
.q-btn.filter-select-button {
  padding: 0;
//   padding-right: 5px;
  position: relative;
  text-align: left !important;
//   min-width: 150px;
}
// We want the dropdown icon to be #001749 but nothing seems to be working
// :deep(.q-btn-dropdown--simple * + .q-btn-dropdown__arrow) {
//   color: #001749 !important;
// }
:deep(.q-btn__content) {
  text-align: left;
  justify-content: left;
}
.q-btn--outline:before {
  border-color: #C5C5C5;
}
:deep(.q-field__prepend) {
  padding-right: 4px;
}
.label, .popup {
  background: #FFFFFF;
  border-radius: 3px;
}

.label {
  color: #5B5B5B;
  margin-left: 1px;
  padding: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 33px;
  background: none;
}
.inner-label {
  font-weight: 500;
  padding: 12px 11px 0px 14px;
}
.loading {
  position: absolute;
  right: 6px;
  background: white;
  z-index: 1;
}
.search {
  padding: 8px 11px;
  height: 57px;

  :deep(.q-field__control), :deep(.q-field__prepend), :deep(.q-field__control-container), :deep(input) {
    height: 40px;
  }
  :deep(.q-field__label) {
    top: 10px;
  }
}
:deep(.q-placeholder) {
  color: #5B5B5B;
}
.selected-count {
  padding: 12px 16px;
  color: #8E8E8E;
  background: #F5F7FB;
}

.q-list {
  overflow-y: auto;
  text-align: left;
  padding-bottom: 52px;

  .q-item {
    color: #3A3A3A;
    border-bottom: 1px solid #C5C5C5;

    &:hover {
      background: #F5F7FB;
    }
  }
}

.check-box {
  font-size: 1em;
}
.controls {
  background: white;
  color: #001749;
  padding: 8px;
  position: relative;
  bottom: 0;
  width: 100%;
}
// lg breakpoint
@media (min-width: $breakpoint-lg-min) {
  .controls {
    button:first-child {
      width: 100px;
    }
    button:last-child {
      width: 80px;
    }
    .q-btn {
      max-width: fit-content;
    }
  }
}
</style>